export const CashbackFlame = (props: React.SVGProps<SVGSVGElement>) => (
    <svg {...props}>
        <use xlinkHref="#flame-ico" />
    </svg>
);
